import React from "react";

function Copyright() {
  return <div className="copyright-text">2022 &copy; Wayfare. All rights reserved.</div>;
}

export default Copyright;
